module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btncreateModel",
    attrs: {
      "rel": "btncreateModel"
    },
    on: {
      "click": function($event) {
        return _vm.modelpopupbuttonClick()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('b', [_vm._v("Create Model")])]), _vm._v(" "), (_vm.showmodel === true) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modelpopContainer"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.closeCreateModel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "topSteps clearfix"
  }, [_c('div', {
    staticClass: "stepsheading stepsin"
  }, [_vm._v("Create Model")]), _vm._v(" "), _c('div', {
    ref: "step1arrow",
    staticClass: "CreatelModelstep1 stepsin",
    class: (_vm.step >= 1) ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.setstep(2)
      }
    }
  }, [_c('span', [_vm._v("Step 1")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    ref: "step2arrow",
    staticClass: "CreatelModelstep2 stepsin",
    class: (_vm.step >= 2) ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.setstep(2)
      }
    }
  }, [_c('span', [_vm._v("Step 2")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    ref: "step3arrow",
    staticClass: "CreatelModelstep3 stepsin",
    class: (_vm.step3) ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.setstep(3)
      }
    }
  }, [_c('span', [_vm._v("Step 3")]), _vm._v(" "), _c('i')])]), _vm._v(" "), _c('div', {}, [_c('div', [_c('form', {
    attrs: {
      "method": "POST",
      "id": "create-job-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formValid($event)
      }
    }
  }, [((_vm.popmsgVisible)) ? _c('div', {
    staticClass: "error text-danger"
  }, [_vm._v(_vm._s(_vm.popinmessage))]) : _vm._e(), _vm._v(" "), (_vm.step1) ? _c('div', {
    staticClass: "createmodelStep1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'error': _vm.errors.has('name')
    },
    attrs: {
      "data-vv-name": "name",
      "name": "name",
      "placeholder": "Enter ...",
      "type": "text",
      "data-vv-validate-on": "input|blur|submit"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear-fix"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "error text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "aclient"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.soption),
      expression: "soption"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'error': _vm.errors.has('client')
    },
    attrs: {
      "data-vv-name": "client",
      "name": "client",
      "data-vv-validate-on": "input|blur|submit"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.soption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectedClient(_vm.soption)
      }]
    }
  }, _vm._l((_vm.res), function(option, index) {
    return _c('option', {
      key: option.clientname.name,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                            " + _vm._s(option.clientname.name) + "\n                          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMarket),
      expression: "selectedMarket"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "selcountries",
    staticClass: "form-control",
    class: {
      'input': true, 'error': _vm.errors.has('market')
    },
    attrs: {
      "disabled": _vm.market.length == 0,
      "required": "",
      "value": "label",
      "data-vv-name": "market",
      "name": "market",
      "data-vv-validate-on": "blur|submit"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMarket = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.setselectedMarket()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "label",
      "disabled": ""
    }
  }, [_vm._v("Select a Country")]), _vm._v(" "), _vm._l((_vm.market), function(countries, key) {
    return _c('option', {
      key: countries.name,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(countries.name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedMarketSubmit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("KPI")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "kpiCheckbox checkbox"
  }, _vm._l((_vm.kpi), function(kpi, index) {
    return _c('span', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedKpi),
        expression: "selectedKpi"
      }],
      attrs: {
        "id": kpi,
        "type": "checkbox",
        "name": ""
      },
      domProps: {
        "value": kpi,
        "checked": Array.isArray(_vm.selectedKpi) ? _vm._i(_vm.selectedKpi, kpi) > -1 : (_vm.selectedKpi)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedKpi,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = kpi,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedKpi = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedKpi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedKpi = $$c
          }
        }, function($event) {
          return _vm.setselectedKpi()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": kpi
      }
    }, [_vm._v(_vm._s(kpi))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.customerType) ? _c('div', [_c('label', [_vm._v("Customer Type")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "kpiCheckbox checkbox"
  }, _vm._l((_vm.customerType), function(customerType, index) {
    return _c('span', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedcustomerType),
        expression: "selectedcustomerType"
      }],
      attrs: {
        "id": customerType.value,
        "type": "checkbox",
        "name": ""
      },
      domProps: {
        "value": customerType.value,
        "checked": Array.isArray(_vm.selectedcustomerType) ? _vm._i(_vm.selectedcustomerType, customerType.value) > -1 : (_vm.selectedcustomerType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedcustomerType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = customerType.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedcustomerType = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedcustomerType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedcustomerType = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": customerType.value
      }
    }, [_vm._v(_vm._s(customerType.name))])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step2) ? _c('div', {
    staticClass: "createmodelStep2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data Source")]), _vm._v(" "), _c('div', {
    ref: "datasourceinfo",
    staticClass: "datasourceinfo"
  }, [_vm._v(_vm._s(_vm.datasourceinfo))]), _vm._v(" "), _vm._l((_vm.datasourcetype), function(datasourcetype) {
    return _c('div', {
      key: datasourcetype.value,
      staticClass: "lookbackradio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.datasourceSelected),
        expression: "datasourceSelected"
      }],
      attrs: {
        "type": "radio",
        "id": datasourcetype.name,
        "checked": ""
      },
      domProps: {
        "value": datasourcetype.value,
        "checked": _vm._q(_vm.datasourceSelected, datasourcetype.value)
      },
      on: {
        "change": [function($event) {
          _vm.datasourceSelected = datasourcetype.value
        }, function($event) {
          return _vm.setdatasourceMessage(datasourcetype.message, datasourcetype.value)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": datasourcetype.name
      }
    }, [_vm._v(_vm._s(datasourcetype.name))])])
  })], 2), _vm._v(" "), _c('label', [_vm._v("Date Range")]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix"
  }, [(_vm.selectedMarketSubmit) ? _c('span', {
    staticClass: "green labltimerange"
  }, [_vm._v("\n                          Available date range\n                          "), _c('strong', [_vm._v(_vm._s(_vm.start_date) + " to " + _vm._s(_vm.end_date))]), _vm._v(" selected by default\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('strong', [(_vm.dates_missing_in_window.length > 0) ? _c('span', {
    staticClass: "missingdateerror"
  }, [_vm._v("Data not available for dates - " + _vm._s(_vm.dates_missing_in_window))]) : _vm._e()])]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "time1",
      "required": "",
      "value": _vm.time1,
      "name": "date1",
      "format": "dd-MM-yyyy",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "placeholder": "Enter Start Date"
    },
    model: {
      value: (_vm.time1),
      callback: function($$v) {
        _vm.time1 = $$v
      },
      expression: "time1"
    }
  }), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "time2",
      "required": "",
      "value": _vm.time2,
      "name": "date2",
      "format": "dd-MM-yyyy",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "placeholder": "Enter End Date"
    },
    model: {
      value: (_vm.time2),
      callback: function($$v) {
        _vm.time2 = $$v
      },
      expression: "time2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dateerror error",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Please enter date within available data range")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Week Commencing Day")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commencingDay),
      expression: "commencingDay"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "value": "label",
      "data-vv-name": "week",
      "name": "week"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.commencingDay = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "label",
      "disabled": ""
    }
  }, [_vm._v("Select a commencing day of week")]), _vm._v(" "), _vm._l((_vm.week), function(week, key) {
    return _c('option', {
      key: week.key,
      domProps: {
        "value": (key + 1)
      }
    }, [_vm._v(_vm._s(week))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group loogback-group"
  }, [_c('label', [_vm._v("Lookback Window")]), _vm._v(" "), _vm._l((_vm.lookbackwindow), function(lookbackwindow) {
    return _c('div', {
      key: lookbackwindow.value,
      staticClass: "lookbackradio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.lookbacktypeselected),
        expression: "lookbacktypeselected"
      }],
      attrs: {
        "type": "radio",
        "id": (lookbackwindow.value)
      },
      domProps: {
        "value": lookbackwindow.value,
        "checked": _vm.lookbackSelected === 0 ? true : false,
        "checked": _vm._q(_vm.lookbacktypeselected, lookbackwindow.value)
      },
      on: {
        "change": [function($event) {
          _vm.lookbacktypeselected = lookbackwindow.value
        }, function($event) {
          return _vm.setLookbacktype(lookbackwindow.value)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": lookbackwindow.value
      }
    }, [_vm._v(_vm._s(lookbackwindow.label))])])
  }), _vm._v(" "), (_vm.lookbacktypeselected === 2) ? _c('div', {
    staticClass: "enterlookback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbackSelected),
      expression: "lookbackSelected"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.lookbackSelected)
    },
    on: {
      "change": function($event) {
        return _vm.checkLookbackNumber()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbackSelected = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Days")]), _vm._v(" "), _c('span', {
    staticClass: "test",
    class: _vm.lookbackValid
  }, [_vm._v("Minimum Value allowed is 1day and Maximum of 90days.")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.step3) ? _c('div', {
    staticClass: "createmodelStep3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('strong', [(_vm.dates_missing_in_window.length > 0) ? _c('span', {
    staticClass: "missingdateerror"
  }, [_vm._v("Data not available for dates - " + _vm._s(_vm.dates_missing_in_window))]) : _vm._e()])]), _vm._v(" "), _c('label', {
    staticClass: "display-block"
  }, [_vm._v("Report Type")]), _vm._v(" "), _vm._l((_vm.reporttype), function(reporttype) {
    return _c('div', {
      key: reporttype.key,
      staticClass: "lookbackradio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.reporttypeSelected),
        expression: "reporttypeSelected"
      }],
      attrs: {
        "type": "radio",
        "id": (reporttype.name)
      },
      domProps: {
        "value": reporttype.value,
        "checked": _vm._q(_vm.reporttypeSelected, reporttype.value)
      },
      on: {
        "change": [function($event) {
          _vm.reporttypeSelected = reporttype.value
        }, function($event) {
          return _vm.reporttypeChange()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": reporttype.name
      }
    }, [_vm._v(_vm._s(reporttype.name))])])
  })], 2), _vm._v(" "), ((_vm.copymodel === true) && _vm.channelgroupings === 'new') ? _c('div', {
    staticClass: "form-group"
  }, [_c('Label', [_vm._v("Use last uploaded channel groupings")]), _vm._v(" "), _c('div', {
    staticClass: "togglebutton"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.existing_channel_groupings_copy),
      expression: "existing_channel_groupings_copy"
    }],
    attrs: {
      "id": "yes",
      "value": "yes",
      "type": "radio",
      "name": "existing_channel_groupings",
      "selected": _vm.existing_channel_groupings_copy === 'yes' ? true : false
    },
    domProps: {
      "checked": _vm._q(_vm.existing_channel_groupings_copy, "yes")
    },
    on: {
      "change": function($event) {
        _vm.existing_channel_groupings_copy = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.existing_channel_groupings_copy === 'yes' ? 'active' : '',
    attrs: {
      "for": "yes"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.existing_channel_groupings_copy),
      expression: "existing_channel_groupings_copy"
    }],
    attrs: {
      "id": "no",
      "type": "radio",
      "value": "no",
      "name": "existing_channel_groupings",
      "selected": _vm.existing_channel_groupings_copy === 'yes' ? false : true
    },
    domProps: {
      "checked": _vm._q(_vm.existing_channel_groupings_copy, "no")
    },
    on: {
      "change": function($event) {
        _vm.existing_channel_groupings_copy = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.existing_channel_groupings_copy === 'yes' ? '' : 'active',
    attrs: {
      "for": "no"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.channel_grouping_url,
      "download": ""
    }
  }, [_vm._v("Download")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('Label', [_vm._v("Channel Grouping Method")]), _vm._v(" "), (_vm.selectedMarketSubmit) ? _c('div', {
    staticClass: "channel-grouping-msg"
  }, [_vm._v("\n                          Latest master-channel-groupings file was uploaded by\n                          "), _c('b', [_vm._v(_vm._s(_vm.chusername) + " on " + _vm._s(_vm.chagroupingdate))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-lrg btn-primary download-channel-grouping",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "downloadchannelgrouping"
    }
  }, [_vm._v("Download Latest")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lookbackradio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelgroupings),
      expression: "channelgroupings"
    }],
    attrs: {
      "name": "channel-grouping",
      "type": "radio",
      "id": "chg-master",
      "value": "master"
    },
    domProps: {
      "checked": _vm._q(_vm.channelgroupings, "master")
    },
    on: {
      "change": function($event) {
        _vm.channelgroupings = "master"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chg-master"
    }
  }, [_vm._v("Use existing master channel grouping file")])]), _vm._v(" "), _c('div', {
    staticClass: "lookbackradio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelgroupings),
      expression: "channelgroupings"
    }],
    attrs: {
      "name": "channel-grouping",
      "type": "radio",
      "id": "chg-new",
      "value": "new"
    },
    domProps: {
      "checked": _vm._q(_vm.channelgroupings, "new")
    },
    on: {
      "change": function($event) {
        _vm.channelgroupings = "new"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chg-new"
    }
  }, [_vm._v("Upload job specific channel grouping file")])]), _vm._v(" "), _c('div', {
    staticClass: "lookbackradio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelgroupings),
      expression: "channelgroupings"
    }],
    attrs: {
      "name": "channel-grouping",
      "type": "radio",
      "id": "chg-newmaster",
      "value": "newmaster"
    },
    domProps: {
      "checked": _vm._q(_vm.channelgroupings, "newmaster")
    },
    on: {
      "change": function($event) {
        _vm.channelgroupings = "newmaster"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chg-newmaster"
    }
  }, [_vm._v("Upload a new master channel grouping file")])]), _vm._v(" "), (_vm.channelgroupings === 'new' || _vm.channelgroupings === 'newmaster') ? _c('div', [_c('label', [_vm._v("Channel Grouping CSV file")]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('input', {
    ref: "filecomp",
    staticClass: "csvupload",
    attrs: {
      "disabled": _vm.copymodel === true && _vm.existing_channel_groupings_copy === 'yes' ? true : false,
      "id": "myfilecsv",
      "type": "file",
      "multiple": "false",
      "required": ""
    },
    on: {
      "change": _vm.onmyFileChange
    }
  })])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Createjob-btnswrapper clearfix"
  }, [((_vm.step !== 1)) ? _c('button', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "id": "Prevcreatejotbtn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gotoBackStep()
      }
    }
  }, [_vm._v("Previous Step")]) : _vm._e(), _vm._v(" "), ((_vm.step === 3)) ? _c('button', {
    ref: "buttoncreatejob",
    staticClass: "btn btn-primary btn-large",
    class: (_vm.submit) ? 'enabled' : 'disabled',
    attrs: {
      "id": "createjotbtn",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.validdateStep3()
      }
    }
  }, [_vm._v("Create Model")]) : _vm._e(), _vm._v(" "), ((_vm.step < 3)) ? _c('button', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "id": "Nextcreatejotbtn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gotoNextStep()
      }
    }
  }, [_vm._v("Next Step")]) : _vm._e()])])])])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                        Name\n                        "), _c('small', [_vm._v("     e.g. Monster | FR | Apply Start | 010117 - 310317")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clear-fix"
  }, [_c('span', {
    staticClass: "error text-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Please select a KPI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clear-fix"
  }, [_c('span', {
    staticClass: "error text-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Please select a Customer Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "error reporterror",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Please select report type")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f8bafa1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Createjob.vue
// module id = 1000
// module chunks = 1